module.exports = __webpack_public_path__ + "images/project-progress-intro-bg-e5a0ae1d6788e5fdd7806a94af9dc5b3.png";